export default {"src":"/_next/static/media/icon-line-dashed.c114c403.svg","height":3,"width":26,"blurWidth":0,"blurHeight":0};